export let moveToFolderNewFolderText = "L6UQZb";
export let moveToArchiveMbxFolderNewFolderText = "eQJfhb";
export let moveToFolderNewGroupFolderText = "iYbqT";
export let searchFolder = "EKZBMe";
export let searchGroupFolder = "Rhq1b";
export let searchArchiveFolder = "A1pxm";
export let moveToSearchSharedFolder = "zvTmk";
export let moveToFolderCreateNewText = "znpvLb";
export let moveToArchiveMbxFolderCreateNewText = "U8dW4";
export let rootFolderString = "RXXTVb";
export let copyToNewFolderText = "JmGsPc";
export default {moveToFolderNewFolderText,moveToArchiveMbxFolderNewFolderText,moveToFolderNewGroupFolderText,searchFolder,searchGroupFolder,searchArchiveFolder,moveToSearchSharedFolder,moveToFolderCreateNewText,moveToArchiveMbxFolderCreateNewText,rootFolderString,copyToNewFolderText};